import { useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../AbstractElements";
import { FaEdit } from "react-icons/fa";
import {useAddTAConfiguration, useGetPolicyList, useTaConfigurationList, useUpdateTAConfiguration } from "./useTAConfiguration";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

type Props = {};

const TAConfigurationTableColumns = (handleEdit: (row: any) => void) => [
  {
    name: "From KM",
    selector: (row: { FromKM: number }) => row.FromKM,
  },
  {
    name: "To KM",
    selector: (row: { ToKM: number }) => row.ToKM,
  },
  {
    name: "Policy Key",
    selector: (row: { PolicyKey: string }) => row.PolicyKey,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary"
          onClick={()=>handleEdit(row)}
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={18} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const TAData = [
  {
    FromKM: 1,
    ToKM: 20,
    PolicyKey: "Sample",
  },
  {
    FromKM: 1,
    ToKM: 20,
    PolicyKey: "Sample",
  },
  {
    FromKM: 1,
    ToKM: 50,
    PolicyKey: "Sample",
  },
  {
    FromKM: 1,
    ToKM: 60,
    PolicyKey: "Sample",
  },
];

const TAConfiguration = (props: Props) => {
  const [isModal, setIsModal] = useState(false);
  const [mode,setMode] = useState('Add');
    const [filterData,setFilterData] = useState({
      page:1,
      limit:10,
      search:'',

      To_KM :'',
      f_Km:'',
      policyKey:'',
      TaConfigId:null ,
    })

      
   const {data:PolicayList} = useGetPolicyList({enable:true}); 
   const{mutate:addTA} = useAddTAConfiguration();
   const{mutate:UpdateTA} = useUpdateTAConfiguration(); 
   const {data,isLoading,isSuccess} = useTaConfigurationList({enable:true,params:{
    page:filterData.page,
    limi:filterData.limit,
    search:filterData.search
   }})
 

  // console.log('PolicayList-------mode----->',mode);
  const handleEdit = (row:any) => {
    // console.log('rowwwwwwwwwwwwwww------>',row);
    setMode('Edit');
    setFilterData((prev:any)=>({
     ...prev,
      To_KM :row.ToKM,
      f_Km:row.FromKM,
      policyKey:row.PolicyKey,
      TaConfigId:row.TaConfigId,
    }))
    setIsModal(true);

  };

  const toggle = () => {
    setIsModal(!isModal);
    setMode(prevMode => (prevMode === 'Add' ? 'Edit' : 'Add'));
  };
  const AddTAConfiguration = () => {
    setFilterData((prev:any)=>({
      ...prev,
      To_KM : null,
      f_Km: null,
      policyKey:'',
      TaConfigId:null
    }))
    setIsModal(true);
  };

  const handleSubmit = () => {
    
    if(mode === "Add" && Number(filterData.f_Km) > 0 && Number(filterData.To_KM) > 0 ){           
      const ReqBody={
       FromKm:Number(filterData.f_Km),
       ToKm: Number(filterData.To_KM),
       PolicyKey:filterData.policyKey
      }


      addTA(ReqBody)
      setFilterData((prev:any)=>({
          ...prev,
        To_KM :'',
        f_Km:'',
        policyKey:'yyyyy'
      }))
      setIsModal(false);
      return;
    }
    
    if(mode === 'Edit' && Number(filterData.f_Km)>0 && Number(filterData.f_Km)>0){
     
      const ReqBody={
       FromKm:Number(filterData.f_Km),
       ToKm: Number(filterData.To_KM),
       PolicyKey:filterData.policyKey
      }
      UpdateTA({ReqBody:ReqBody, id:filterData.TaConfigId})
      setIsModal(false);
      return;
    }

     
  };

 const handleSerach = (val:any)=>{
         setFilterData((prev:any)=>({
          ...prev,
          search:val
         }))
  }
  const handleOnChangeRowsPerPage=(limit:any,page:any)=>{
    
    setFilterData((prav:any)=>({
       ...prav,
       limit:limit,
       page:page
    }))

  }
  const handlePagination =(page:number)=>{
      setFilterData((prev:any)=>({
       ...prev,
       page:page
      }))
  }

  return (
    <div className="p-2">
      <PageHeader
        title="TA Configuration"
        buttons={[
          {
            label: "+Add TA Configuration",
            onClick: AddTAConfiguration,
          }, 
          {
            label: "Excle",
            onClick: () => alert("Add Excle"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Add CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
       search
        Title="TA Configuration"
        columns={TAConfigurationTableColumns(handleEdit)}
        data={(!isLoading && isSuccess && data?.data) || []}
        paginationTotalRows={(!isLoading && isSuccess && data.rowData.data.total) || 0}
        handleSearch={(val:any)=>handleSerach(val)}
        onChangeRowsPerPage={(newPerPage:any,page:any)=>handleOnChangeRowsPerPage(newPerPage,page)}
        onChangePage={(pageNo:number)=>handlePagination(pageNo)}


      />
      <RouteModal
        size="sm"
        toggle={toggle}
        isOpen={isModal}
        title= {mode ==='Edit'? 'Edit TA Configuration': 'Add TA Configuration'}
        content={
          <form>
            <div className="row mb-0">
              <CustomInput
               required
                type="number"
                label="Form KM *"
                value={filterData.f_Km}
                style={{ marginTop: 0, borderColor: "#d6d6d6",borderRadius:'4px'}}
                onChange={(e)=>setFilterData((prev:any)=>({...prev,f_Km:e.target.value}))}
              />
              <CustomInput
               required
               type="number"
                value={filterData.To_KM}
                label="To KM *"
                style={{ marginTop: 0, borderColor: "#d6d6d6",borderRadius:'4px' }}
                onChange={(e)=>setFilterData((prev:any)=>({...prev,To_KM:e.target.value}))}
              />
              <ReusableDropdown
                DropdownHeading="Policy Key"
                options={(PolicayList?.data) || []}
                value={filterData.policyKey}
                onChange={(opt)=>setFilterData((prev:any)=>({...prev,policyKey:opt}))}
              />

              <div className="d-flex justify-content-start gap-2 mt-4">
                <Btn
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  onClick={handleSubmit}
                >
                  Submit
                </Btn>
                <Btn
                  onClick={toggle}
                  style={{ backgroundColor: "#F9FAFC", color: "#000" }}
                >
                  {""}
                  Cancel
                </Btn>
              </div>
            </div>
          </form>
        }
      />
    </div>
  );
};

export default TAConfiguration;
